export const getTodayISO = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const getISOFromDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const getPreviousDayISO = (isoDate: string): string => {
    const date = new Date(isoDate);
    date.setDate(date.getDate() - 1);
    return getISOFromDate(date);
};

export const formatDateDisplay = (isoDate: string): string => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) return isoDate;

    const currentYear = new Date().getFullYear();
    const options: Intl.DateTimeFormatOptions = { month: "short", day: "numeric" };
    if (date.getFullYear() !== currentYear) {
        options.year = "numeric";
    }

    return date.toLocaleDateString("en-US", options);
};

export const formatDateFull = (isoDate: string): string => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) return isoDate;

    const currentYear = new Date().getFullYear();
    const options: Intl.DateTimeFormatOptions = { weekday: 'short', month: 'short', day: 'numeric' };
    if (date.getFullYear() !== currentYear) {
        options.year = "numeric";
    }

    return date.toLocaleDateString("en-US", options);
}

export const getLast7DaysISO = (): string[] => {
    const dates = [];
    for (let i = 0; i < 7; i++) {
        const d = new Date();
        d.setDate(d.getDate() - (6 - i));
        dates.push(getISOFromDate(d));
    }
    return dates;
};

export const formatDateIndian = (isoDate: string): string => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) return isoDate;

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};
